import * as React from "react";

import type { IIconStyles } from "@fluentui/react/lib/Icon";
import { Icon } from "@fluentui/react/lib/Icon";
import { mergeStyles, mergeStyleSets } from "@fluentui/react/lib/Styling";

import { AppGalleryButton } from "@1js/acui-gallery";

import {
  iconTextStyles,
  previewIconStyles,
} from "../AppIconFullGallery/AppIconFullGallery.styles";
import type { AppIconGalleryButtonProps } from "../AppIconFullGalleryButton";

export const AppIconPreviewGalleryButton: React.FunctionComponent<AppIconGalleryButtonProps> =
  React.memo((galleryButton: AppIconGalleryButtonProps) => {
    const styles = galleryButton.previewIconProps
      ? mergeStyleSets(
          previewIconStyles,
          galleryButton.previewIconProps.styles as IIconStyles
        )
      : previewIconStyles;
    return (
      <AppGalleryButton
        {...galleryButton}
        automationType="AppIconPreview"
        uniqueId={galleryButton.id}
        title={undefined}
        label={galleryButton.title}
        ariaLabel={galleryButton.title}
        shouldTakeFocus={true}
      >
        <Icon {...galleryButton.previewIconProps} styles={styles} />
        {galleryButton.label && (
          <div
            className={mergeStyles(iconTextStyles, galleryButton.style?.label)}
          >
            {" "}
            {galleryButton.label}{" "}
          </div>
        )}
      </AppGalleryButton>
    );
  });
